import { render, staticRenderFns } from "./comentario.vue?vue&type=template&id=cb4faa7e&scoped=true"
import script from "./comentario.vue?vue&type=script&lang=js"
export * from "./comentario.vue?vue&type=script&lang=js"
import style0 from "./comentario.vue?vue&type=style&index=0&id=cb4faa7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4faa7e",
  null
  
)

export default component.exports